import { DATA_MODEL_SCHEMA_RESOURCE_KINDS } from 'common/types/kraken-core/DataModelSchemaResource'

/**
 * Filters out INTERNAL resources from a list of data model schema resources
 * @param resources - Array of data model schema resources
 * @returns Filtered array excluding INTERNAL resources
 */
export const filterValidResources = (resources: any[]) => {
  return resources.filter(
    (resource: any) => resource.kind !== DATA_MODEL_SCHEMA_RESOURCE_KINDS.INTERNAL
  )
}

/**
 * Gets the count of valid resources (excluding INTERNAL resources)
 * @param resources - Array of data model schema resources
 * @returns Count of valid resources
 */
export const getValidResourcesCount = (resources: any[]) => {
  return filterValidResources(resources).length
}
